import styled from '@emotion/styled';
import type { FacebookTableViewProps } from 'types/fbTable';
import { Header } from 'ui/Header';
import LoggedInAsBrandBadge from 'ui/LoggedInAsBrandBadge';
import FacebookTableAdAccountId from './FacebookTable.AdAccountId.Container';
import FacebookTableLastUpdatedAt from './FacebookTable.LastUpdatedAt.Container';

const HeaderWrapper = styled.div`
  padding-left: 8px;
`;

const HeaderItemsWrapper = styled.div`
  margin-left: 16px;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FacebookTableHeaderView = ({
  loading,
  metaAdAccount,
  lastUpdate
}: Pick<FacebookTableViewProps, 'loading' | 'metaAdAccount' | 'lastUpdate'>) => (
  <HeaderWrapper>
    <Header title="Manage" titleAppendText={<LoggedInAsBrandBadge />}>
      <HeaderItemsWrapper>
        <FacebookTableAdAccountId loading={loading} metaAdAccount={metaAdAccount} />
        <FacebookTableLastUpdatedAt loading={loading} lastUpdate={lastUpdate} />
      </HeaderItemsWrapper>
    </Header>
  </HeaderWrapper>
);

export default FacebookTableHeaderView;
